module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "overlay": _vm.modalOverlay,
      "loading": _vm.loading || _vm.parentLoading
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('Navbar', {
    attrs: {
      "type": _vm.type,
      "estore-display": _vm.shouldDisplayEstore,
      "validations": _vm.$v.form
    },
    on: {
      "select-tab": _vm.selectTab
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }), _vm._v(" "), (_vm.activeTab === _vm.TABS.GENERAL) ? _c('GeneralForm', {
    model: {
      value: (_vm.form.generalForm),
      callback: function($$v) {
        _vm.form.generalForm = $$v
      },
      expression: "form.generalForm"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldDisplayEstore && _vm.activeTab === _vm.TABS.E_STORE) ? _c('EditBrandEStore', {
    model: {
      value: (_vm.form.estoreForm),
      callback: function($$v) {
        _vm.form.estoreForm = $$v
      },
      expression: "form.estoreForm"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === _vm.TABS.BRAND_ACCESS) ? _c('BrandAccess', {
    model: {
      value: (_vm.form.accessForm),
      callback: function($$v) {
        _vm.form.accessForm = $$v
      },
      expression: "form.accessForm"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.modalOverlay) ? _c('template', {
    slot: "overlay"
  }, [_c('OverlayErrorMessage', {
    attrs: {
      "form": _vm.$v.form
    },
    on: {
      "close": function($event) {
        _vm.setModalOverlay(false)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactive-color": _vm.$v.form.$invalid,
      "disabled": _vm.$v.form.$invalid,
      "background-color": _vm.brand.linksColor
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")) + "\n        ")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa360c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/BrandForm.vue
// module id = 3068
// module chunks = 0